// Mock data for Fieldstech Hero Section

export const heroData = {
  tagline: "Especialistas en Google Cloud para PYMES",
  mainHeadline: "Migra a la nube con un equipo que habla tu idioma",
  subHeadline: "Acompañamiento humano en Google Cloud para PYMES. Planeamos, migramos y optimizamos tu infraestructura sin riesgos ni complicaciones.",
  primaryCTA: {
    text: "Solicita diagnóstico gratuito",
    action: () => console.log("Diagnóstico gratuito solicitado")
  },
  secondaryCTA: {
    text: "Conoce cómo funciona",
    action: () => console.log("Ver cómo funciona")
  },
  trustSignals: [
    {
      id: 1,
      text: "Certificados Google Cloud",
      icon: "BadgeCheck"
    },
    {
      id: 2,
      text: "Soporte 100% en español",
      icon: "MessageCircle"
    },
    {
      id: 3,
      text: "Metodología ágil",
      icon: "Zap"
    }
  ]
};

// Mock data for Services Section

export const servicesData = {
  sectionTitle: "Nuestros Servicios",
  sectionSubtitle: "Soluciones diseñadas para PYMES mexicanas que buscan modernizarse sin complicaciones.",
  services: [
    {
      id: 1,
      icon: "CloudUpload",
      title: "Migración Guiada a GCP",
      description: "Migra tus aplicaciones, bases de datos y servidores a Google Cloud sin riesgos. Te acompañamos paso a paso.",
      benefits: [
        "Diagnóstico inicial gratuito",
        "Reducción de costos hasta 40%",
        "Soporte post-migración incluido"
      ],
      cta: {
        text: "Saber más sobre migración",
        action: () => console.log("Ver detalles de migración")
      }
    },
    {
      id: 2,
      icon: "Code",
      title: "Modernización de Sistemas Legacy",
      description: "Actualizamos sistemas obsoletos (VB6, SQL Server 2000, etc.) a tecnologías modernas como Java y Spring Boot.",
      benefits: [
        "Elimina riesgos de seguridad",
        "Mejora rendimiento y mantenibilidad",
        "Integración con APIs y cloud"
      ],
      cta: {
        text: "Explorar modernización",
        action: () => console.log("Ver modernización")
      }
    }
  ],
  finalCTA: {
    text: "¿No estás seguro de cuál servicio necesitas?",
    subtext: "Agenda una llamada diagnóstica sin compromiso.",
    buttonText: "Agendar asesoría gratuita",
    action: () => console.log("Agendar asesoría")
  }
};

// Mock data for Why Fieldstech Section

export const whyFieldstechData = {
  sectionTitle: "¿Por qué Fieldstech?",
  sectionSubtitle: "No solo migramos tu infraestructura: nos convertimos en tu aliado tecnológico.",
  reasons: [
    {
      id: 1,
      icon: "MessageCircle",
      title: "Acompañamiento humano 100% en español",
      description: "Hablamos tu idioma, literal y figurativamente. Te guiamos paso a paso sin tecnicismos innecesarios."
    },
    {
      id: 2,
      icon: "Award",
      title: "Especialistas exclusivos en Google Cloud",
      description: "No somos \"todólogos\". Somos expertos certificados en GCP, lo que garantiza profundidad técnica y mejores resultados."
    },
    {
      id: 3,
      icon: "Building2",
      title: "Enfoque en PYMES mexicanas",
      description: "Entendemos tu contexto, tus retos y tu presupuesto. Diseñamos soluciones a tu medida, no plantillas genéricas."
    },
    {
      id: 4,
      icon: "ShieldCheck",
      title: "Cumplimiento normativo local",
      description: "Te ayudamos a navegar la LFPDP, NOM-036 y requisitos del T-MEC. Migrar a la nube también es cumplir con la ley."
    }
  ]
};

// Mock data for Footer

export const footerData = {
  company: {
    name: "Fieldstech",
    description: "Acompañamos a PYMES mexicanas en su transformación digital con migración guiada a Google Cloud. Soporte 100% en español.",
    logo: "CloudCog"
  },
  services: {
    title: "Servicios",
    links: [
      {
        id: 1,
        text: "Migración Guiada a GCP",
        action: () => console.log("Navigate to migration")
      },
      {
        id: 2,
        text: "Modernización de Sistemas Legacy",
        action: () => console.log("Navigate to modernization")
      }
    ]
  },
  contact: {
    title: "Contacto",
    email: "customers@fieldstech.io"
  },
  legal: {
    title: "Legal",
    links: [
      {
        id: 1,
        text: "Aviso de privacidad",
        action: () => console.log("Navigate to privacy policy")
      },
      {
        id: 2,
        text: "Términos y condiciones",
        action: () => console.log("Navigate to terms")
      }
    ],
    copyright: "© 2026 Fieldstech. Todos los derechos reservados."
  }
};

// Mock data for Navbar

export const navbarData = {
  logo: {
    name: "Fieldstech",
    icon: "CloudCog"
  },
  cta: {
    text: "Contáctanos",
    action: () => console.log("Contact button clicked")
  }
};
